import { Component } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { LoaderService } from '../../../services/loader.service';
import { LoginService } from '../../../services/login.service';
import { AppConstants } from '../../../shared/app.constants';

@Component({
  selector: 'ness-administrator-list',
  templateUrl: './administrator-list.component.html'
})
export class AdministratorListComponent  {

  cols: any[] = [
    { field: 'LastName', header: 'Last name' },
    { field: 'FirstName', header: 'First name' },
    { field: 'Email', header: 'Email' },
    { field: 'UserType', header: 'User Type' }
  ];
  rows: number = AppConstants.defaultTableRows;

  allAdmins: ServerModels.UserInfoViewModel[] = [];
  allPowerUsers: ServerModels.UserInfoViewModel[] = [];
  fdAdmins: ServerModels.UserInfoViewModel[] = [];
  fdPowerUsers: ServerModels.UserInfoViewModel[] = [];
  stateLocalAdmins: ServerModels.UserInfoViewModel[] = [];
  stateLocalPowerUsers: ServerModels.UserInfoViewModel[] = [];
  hqAdmins: ServerModels.UserInfoViewModel[] = [];
  hqPowerUsers: ServerModels.UserInfoViewModel[] = [];

  private _unsubscribe$: Subject<void> = new Subject<void>();
  constructor(private loaderService: LoaderService,
    private loginService: LoginService) { }

  ngOnInit() {
    this._getAdminUserListViewModel(0);
    this._getPowerUserListViewModel(0);
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  private _getAdminUserListViewModel(pageNumber: number): void {
    //get admin lists
    this.loginService.getAdmins().pipe(takeUntil(this._unsubscribe$)).subscribe({
      next: (user:ServerModels.UserInfoViewModel[]) => {
        user.forEach(u => u.ConcatenatedRoles = u.Roles.map(p => p.Name).join("; "));
        this.allAdmins = user;
      },
      complete: () => {
        this.allAdmins.sort((a, b) => a.LastName.toLocaleUpperCase() > b.LastName.toLocaleUpperCase() ? 1 : -1);
        this.fdAdmins = this.allAdmins.filter(u => u.UserType.UserTypeDsiaplyName == "ATF Field Division");
        this.stateLocalAdmins = this.allAdmins.filter(u => u.UserType.UserTypeDsiaplyName == "State and Local LE");
        this.hqAdmins = this.allAdmins.filter(u => u.UserType.UserTypeDsiaplyName == "ATF HQ");
      },
      error: (err:any) => {
        console.log(err);
      }
    });
  }

  private _getPowerUserListViewModel(pageNumber: number): void {
    //get power user lists
    this.loginService.getPowerUsers().pipe(takeUntil(this._unsubscribe$)).subscribe({
      next: (user: ServerModels.UserInfoViewModel[]) => {
        user.forEach(u => u.ConcatenatedRoles = u.Roles.map(p => p.Name).join("; "));
        this.allPowerUsers = user;
      },
      complete: () => {
        this.allPowerUsers.sort((a, b) => a.LastName.toLocaleUpperCase() > b.LastName.toLocaleUpperCase() ? 1 : -1);
        this.fdPowerUsers = this.allPowerUsers.filter(u => u.UserType.UserTypeDsiaplyName == "ATF Field Division");
        this.stateLocalPowerUsers = this.allPowerUsers.filter(u => u.UserType.UserTypeDsiaplyName == "State and Local LE");
        this.hqPowerUsers = this.allPowerUsers.filter(u => u.UserType.UserTypeDsiaplyName == "ATF HQ");
      },
      error: (err:any) => {
        console.log(err);
      }
    });
  }
}
